import React, { Suspense, lazy } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

/* loader component for Suspense*/
import PageLoader from './components/Common/PageLoader';
import Base from './components/Layout/Base';
import BasePage from './components/Layout/BasePage';
import useAuthStore from './stores/authStore.js';

// APPLICATION
import UserActions from './components/Application/userActions';
import Simulator from './components/Application/simulator';
import Cldr from './components/Application/calendar.jsx';
import Jobs from './components/Application/jobs';
import Applicants from './components/Application/applicants';
import Dashboard from './components/Application/dashboard';
import JobDetails from './components/Application/jobDetails';
import Competences from './components/Application/competences';
import Applications from './components/Application/applications';
import ApplicationDetails from './components/Application/applicationDetails';
import ApplicationSettings from './components/Application/Settings/settings.jsx';
import Overview from './components/Application/Admin/overview.jsx';
import TenantDetails from './components/Application/Admin/tenantDetails';
import CommentsAndHistoryTimeline from './components/Application/Components/Timelines/commentsandHistoryTimeline';
import InsertApplicant from './components/Application/Applicant/insertApplicant.jsx';
import PaymentForm from './components/Application/Stripe/PaymentForm.jsx';

// Application Login, Register, Recover...
//import Error from "./components/Application/Pages/error";

/* Used to render a lazy component with react-router */
const waitFor = (Tag) => (props) => <Tag {...props} />;

// Application Login, Register, Recover...
const Error = lazy(() => import('./components/Application/Pages/error'));
const Login = lazy(() => import('./components/Application/Pages/login'));
const Register = lazy(() => import('./components/Application/Pages/register'));
const Recover = lazy(() => import('./components/Application/Pages/recover'));
const ResetPasswordApp = lazy(() => import('./components/Application/Pages/resetPassword'));
const ApplicationCreation = lazy(() => import('./components/Application/applicationCreation'));

// List of routes that uses the page layout
// listed here to Switch between layouts
// depending on the current pathname
const listOfPages = [
  '/register',
  '/login',
  '/recover',
  '/recover',
  '/lock',
  '/notfound',
  '/error500',
  '/maintenance',
  '/error',
  '/resetPasswordAppTemp',
  '/portal',
  '/jobDetails/:id',
  '/savedJobList',
];

const Routes = ({ location }) => {
  const currentKey = location.pathname.split('/')[1] || '/';
  const timeout = { enter: 500, exit: 500 };

  const loggedIn = useAuthStore((state) => state.loggedIn);
  const animationName = 'rag-fadeIn';

  if (
    listOfPages.indexOf(location.pathname) > -1 ||
    location.pathname.startsWith('/jobDetails/') ||
    location.pathname.startsWith('/applicationCreation/')
  ) {
    return (
      // Page Layout component wrapper
      <BasePage>
        <Suspense fallback={<PageLoader />}>
          <Switch location={location}>
            <Route path="/applicationCreation/:id/" component={ApplicationCreation} />
            <Route path="/error" component={waitFor(Error)} />
            <Route path="/register" component={waitFor(Register)} />
            <Route path="/login" component={waitFor(Login)} />
            <Route path="/recover" component={waitFor(Recover)} />
            <Route path="/resetPasswordAppTemp" component={waitFor(ResetPasswordApp)} />
          </Switch>
        </Suspense>
      </BasePage>
    );
  } else {
    return (
      // Layout component wrapper
      // Use <BaseHorizontal> to change layout
      <Base>
        <TransitionGroup>
          <CSSTransition key={currentKey} timeout={timeout} classNames={animationName} exit={false}>
            <div>
              <Suspense fallback={<PageLoader />}>
                <Switch location={location}>
                  {/*Application*/}
                  <Route path="/dashboard" component={Dashboard} />
                  <Route path="/competences" component={Competences} />
                  <Route path="/userActions" component={UserActions} />
                  <Route path="/simulator" component={Simulator} />
                  <Route path="/jobs/:id" component={JobDetails} />
                  <Route path="/jobs" component={Jobs} />
                  <Route path="/applicants/commentsAndHistoryTimeline" component={CommentsAndHistoryTimeline} />
                  <Route path="/applicants" component={Applicants} />
                  <Route path="/cldr" component={Cldr} />
                  <Route path="/settings/companyProfile" component={ApplicationSettings} />
                  <Route path="/settings/profile" component={ApplicationSettings} />
                  <Route path="/settings/account" component={ApplicationSettings} />
                  <Route path="/settings/notifications" component={ApplicationSettings} />
                  <Route path="/settings" component={ApplicationSettings} />
                  <Route path="/overview/:id" component={TenantDetails} />
                  <Route path="/overview" component={Overview} />
                  <Route path="/payment" component={PaymentForm} />
                  {/* // more specific route has to be on top!!! */}
                  <Route path="/applications/details" component={ApplicationDetails} />
                  <Route path="/applications" component={Applications} />
                  <Route path="/insertApplicant" component={InsertApplicant} />
                  {loggedIn ? <Redirect to="/dashboard" /> : <Route path="/login" component={waitFor(Login)} />}
                </Switch>
              </Suspense>
            </div>
          </CSSTransition>
        </TransitionGroup>
      </Base>
    );
  }
};

export default withRouter(Routes);
